import { render, staticRenderFns } from "./LiveSeance.vue?vue&type=template&id=cdbd5e38&scoped=true&"
import script from "./LiveSeance.vue?vue&type=script&lang=js&"
export * from "./LiveSeance.vue?vue&type=script&lang=js&"
import style0 from "./LiveSeance.vue?vue&type=style&index=0&id=cdbd5e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbd5e38",
  null
  
)

export default component.exports